<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Leagues">
        <template #header>
            Leagues
        </template>

        <GlobalLeaderboard></GlobalLeaderboard>

        <div class="h-10 w-100 bg-gray-900"></div>        

        <div>
            <div class="text-2xl text-center font-bold mt-3 text-white">Global Leagues</div>
            <div class="sm:py-4">
                <div class="flex sm:justify-center gap-4 ">
                    <button class="block my-4 mx-2 sm:m-0 px-2 py-2 border text-xs md:text-sm font-semibold rounded-md border-racing-stars-yellow text-racing-stars-yellow" @click="createLeagueModal = true">Create League</button>
                    <a href="/leagues/myleagues"
                    class="block my-4 mx-2 sm:m-0 px-2 py-2 border text-xs md:text-sm font-semibold rounded-md border-racing-stars-yellow text-racing-stars-yellow text-center">
                    My Leagues
                    </a>
                    <button :secondary="true" @click="joinLeagueModal = true" class="block my-4 mx-2 sm:m-0 px-2 py-2 border text-xs md:text-sm font-semibold rounded-md border-racing-stars-yellow text-racing-stars-yellow">Join Private League</button>
                </div>
                <div v-if="leagues.length" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-3 sm:pt-4 gap-4 mt-2 mx-2 p-2">
                    <div v-for="(league) in leagues" :key="league.inLeague" :class="[league.owner === 'Admin' ? 'order-first' : '']">
                        <div class="bg-transition duration-500 ease-in-out bg-gray-900 text-white rounded-md shadow-lg max-h-[650px] overflow-scroll border border-racing-stars-yellow">
                            <a :href="'../league/' + league.code">
                                <div class="sm:p-4 bg-cover bg-center border-b" :style="(league.owner === 'Admin' && $page.props.settings.site_name === 'Racing Stars') ? `background-image: url(/images/rs-league-cover.png)` : ((league.owner === 'Admin' && $page.props.settings.site_name === 'Racing League') ? `background-image: url(/images/rl-league-cover.svg)` : (league.cover_picture ? `background-image: url(/storage/${league.cover_picture})` : 'background-image: url(/images/horsecover.jpg)'))">
                                    <div>
                                        <!-- <button v-if="league.inLeague" class="inline-flex self-end items-center sm:m-0 px-4 py-2 border border-transparent text-sm font-medium rounded-md border-white text-white hover:text-gray-500 bg-green-800">
                                            <CheckIcon class="h-5 w-5 mr-1 text-green-400" aria-hidden="true" />
                                            Joined
                                        </button>
                                        <button v-else @click="joinLeague(league)" class="inline-flex self-end items-center sm:m-0 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-black bg-racing-stars-yellow hover:text-gray-500">
                                            <PlusIcon class="h-3.5 w-3.5 mr-1" aria-hidden="true"/>
                                            Join
                                        </button> -->
                                        <div class="flex justify-between">
                                            <div class="m-1 h-10 inline-flex self-end items-center sm:m-0 px-2 py-1 border text-sm font-medium rounded-md text-white bg-gray-900">
                                                <ExternalLinkIcon class="w-6 md:w-8 text-white"/>
                                            </div>
                                            <div class="m-1 h-10 inline-flex self-end items-center sm:m-0 px-2 py-1 border text-sm font-medium rounded-md text-white bg-gray-900">
                                                <UserGroupIcon class="w-6 md:w-8 pr-1"/>
                                                <p>{{ league.members }}</p>
                                            </div>
                                        </div>
                                        <div class="flex relative flex-col justify-center order-first md:w-1/2 xl:w-1/2 mx-auto p-1 rounded-md mt-2 h-36 max-h-36">

                                        </div>
                                        <!-- <h1 class="text-center p-4 text-lg font-bold text-white mx-auto max-h-20 overflow-hidden">{{ league.name }}</h1> -->
                                    </div>
                                </div>
                            </a>
                            <div class="sm:rounded flex flex-col bg-transparent">
                                <div class="flex flex-col justify-center -mb-10">
                                    <span class="flex flex-col my-auto text-sm text-white h-full w-full mt-2">
                                        <span class="my-auto">
                                             <p class="font-semibold my-auto text-lg px-3 lg:text-xl">{{league.name}}</p>
                                        </span>
                                        <span class="my-auto">
                                             <p class="font-medium my-auto text-sm px-3 lg:text-base">Owner: {{league.owner}}</p>
                                        </span>
                                    </span>
                                </div>
                                <!-- <span class="my-auto mx-auto text-center">
                                     <p class="font-semibold mx-auto my-auto text-lg">Owner</p>
                                     <p class="mx-auto md:text-lg">{{ league.owner }}</p>
                                </span> -->
                                <div class="mt-10 px-3">
                                    <button v-if="league.inLeague" class="flex bg-green-800 m-2 mb-1 py-2 font-medium mx-auto rounded-md w-full px-3">
                                        <div class="flex justify-center w-full">
                                            <p class="font-medium ">JOINED</p>
                                            <CheckIcon class="h-6 w-6 text-white" aria-hidden="true" />
                                        </div>
                                    </button>
                                    
                                    <button v-else  @click="joinLeague(league)" class="flex bg-racing-stars-yellow m-2 mb-1 py-2 font-medium mx-auto rounded-md w-full px-3">
                                        <div class="flex justify-center w-full">
                                            <p class="font-medium text-black">JOIN</p>
                                            <PlusIcon class="h-6 w-6 text-black" aria-hidden="true" />
                                        </div>
                                    </button>
                                </div>
    
                                <Disclosure as="div" class="px-3" v-slot="{ open }">
                                    <DisclosureButton class="flex bg-gray-600 m-2 mt-1 py-2 font-medium mx-auto rounded-md w-full px-3" @click="() => (isActive = !isActive)">
                                        <div class="flex justify-center w-full">
                                            <p class="font-medium ">DESCRIPTION</p>
                                            <ChevronDownIcon class="h-6 w-6" :class="open && '-rotate-180'"></ChevronDownIcon>
                                        </div>
                                    </DisclosureButton>
                                    <DisclosurePanel as="div" class="text-center">
                                        <p v-if="league.description" class="p-4 text-md text-white text-center">{{ league.description }}</p>
                                        <p v-else class="text-left p-4 text-md text-white">No description set for this league</p>
                                    </DisclosurePanel>
                                </Disclosure>
                            </div>
                        </div>
                    </div>
                </div>
                <empty-state v-else :icon="UserGroupIcon" :actions="emptyStateActions" title="No leagues" subtitle="Get started by creating or joining a league." />
            </div>
            <create-league :show="createLeagueModal" @close="createLeagueModal = false" />
            <join-league :show="joinLeagueModal" @close="joinLeagueModal = false" />
        </div>
    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/Layout.vue'
import { ref, watch, getCurrentInstance } from 'vue'
import { UserGroupIcon, ArrowSmRightIcon } from '@heroicons/vue/solid'
import { ShareIcon, XIcon, PlusIcon, CheckIcon, UserIcon, ChevronDownIcon, ExternalLinkIcon } from '@heroicons/vue/outline'
import { Inertia } from '@inertiajs/inertia'
import Vue from 'vue';
import JetInput from '@/Jetstream/Input.vue'
import JetTextarea from '@/Jetstream/Textarea.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import TwModal from '@/Global/Elements/TwModal.vue'
import { ExclamationCircleIcon } from '@heroicons/vue/solid'
import {Disclosure, DisclosureButton, DisclosurePanel} from '@headlessui/vue'
import CreateLeague from '@/Global/CreateLeague.vue'
import JoinLeague from '@/Global/JoinLeague.vue'
import GlobalLeaderboard from '@/Pages/GlobalLeaderBoard/Leaderboard.vue'

export default {
    props: {
        user: {},
        leagues: Object
    },

    data() {
        return {
            isActive: false,
        };
    },

    components: {
        AppLayout,
        UserGroupIcon,
        JetInput,
        JetTextarea,
        JetInputError,
        JetButton,
        JetLabel,
        JetFormSection,
        TwModal,
        ExclamationCircleIcon,
        ShareIcon,
        XIcon,
        PlusIcon,
        CheckIcon,
        UserIcon,
        ChevronDownIcon,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ArrowSmRightIcon,
        CreateLeague,
        JoinLeague,
        ExternalLinkIcon,
        GlobalLeaderboard
    },

    setup(props) {

        const createLeagueModal = ref(false)
        const joinLeagueModal = ref(false)

        function joinLeague(league) {
            axios.patch(route('leagues.update', { code: league.code }), { code: league.code }).then(function(response) {
                league.inLeague = true;
            });
        }
        //make the joined == true when have time

        return {

            pageTitle: 'Leagues',
            UserGroupIcon,
            ShareIcon,
            joinLeague,
            createLeagueModal,
            joinLeagueModal

        }
    },
    methods() {

    }
}

</script>
